import { Prisma } from '@prisma/client';
import axiosInstance from '../api';

const offersService = {
  find: async (params?: Prisma.offersFindManyArgs) => {
    const res = await axiosInstance.get('/offers', { params });
    return res.data;
  },
  post: async (
    data: Prisma.offersCreateWithoutUserInput & { sessionId: string },
    buyer = false
  ) => {
    const res = await axiosInstance.post('/offers', data, {
      params: { buyer },
    });
    return res.data;
  },
  patch: async (id: string, data: Prisma.offersUpdateInput, token?: string) => {
    const res = await axiosInstance.patch(
      `/offers/${id}`,
      { ...data },
      token ? { params: { token } } : {}
    );
    return res.data;
  },
  generateAccessToken: async (offerId: string) => {
    const res = await axiosInstance.post(`/offers/${offerId}/generate-token`);
    return res.data;
  },
  getWithToken: async (offerId: string, token: string) => {
    const res = await axiosInstance.get(`/offers/${offerId}`, {
      params: { token },
    });
    return res.data;
  },
  downloadDocuments: async (offerId: string, token?: string) => {
    const url = token
      ? `/offers/${offerId}/download-documents?token=${token}`
      : `/offers/${offerId}/download-documents`;

    const res = await axiosInstance.get(url, {
      responseType: 'blob',
    });
    return res.data;
  },
};

export default offersService;
